export default "__VITE_ASSET__BJB5Pqpg__"